import { createApi } from '@reduxjs/toolkit/query/react';
import qwDimensions from '../common/client/qwDimensions';

const cplBaseQuery = async ({ id }) => {
  try {
    const result = await qwDimensions.get(`/v2/compositions/${id}`);
    return { data: result.data };
  } catch (axiosError) {
    let err = axiosError;
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export const cplApiSlice = createApi({
  reducerPath: 'compositionsApi',
  baseQuery: cplBaseQuery,
  serializeQueryArgs: (query) => query.queryArgs,
  keepUnusedDataFor: 28800,
  endpoints: (builder) => ({
    fetchCpl: builder.query({
      query: (id) => {
        return { id };
      },
    }),
  }),
});

export const { useFetchCplQuery } = cplApiSlice;
